import { State } from 'Libs/redux/types';

export const selectMagicCodeExistance =
  (value: string) =>
  (state: State): boolean => {
    return !!state.entities.magicCode.magicCodesList.find((code) => {
      return code.code.toLowerCase() === value.toLowerCase();
    });
  };

export const selectMagicCodeExistanceMetadata = (state: State) => state.entities.magicCode.metadata;
